/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { memoizedFetchSiteUserPersonalization } from '@jira/platform__services-personalization/src/services/site-user/index.tsx';
import type { Trait } from '@jira/platform__services-personalization/src/types.tsx';

export const isNewActiveUser = async (
	cloudId: string,
	userId: string,
	newActiveDays = 14,
): Promise<boolean> => {
	const userTraits = await memoizedFetchSiteUserPersonalization({ cloudId, userId });
	return findAndCheckActiveDate(userTraits, newActiveDays);
};

const findAndCheckActiveDate = (traits: Trait[], newActiveDays: number): boolean => {
	const traitName = 'jira_first_active';

	const firstActiveTrait = traits.find((trait) => trait.name === traitName);

	if (firstActiveTrait?.value) {
		const oneWeekActive = new Date(firstActiveTrait?.value.toString());
		oneWeekActive.setDate(oneWeekActive.getDate() + newActiveDays);
		const today = new Date();
		return today <= oneWeekActive;
	}
	return true;
};
